import React, { Component } from 'react';
import type { Store } from 'redux';
import AppStyle from '@atlassian/jira-common-components-app-style';
import isShallowEqual from '@atlassian/jira-common-util-is-shallow-equal';
import { Provider } from '@atlassian/jira-react-redux';
import type { AppProps } from './model/types';
import rootEpic from './ops';
import createStore from './state';
import { initializeAppProps } from './state/actions';
import type { State } from './state/types';
import View from './view';

export type Props = AppProps;

// eslint-disable-next-line jira/react/no-class-components
export default class ProjectType extends Component<Props> {
	constructor(props: Props) {
		super(props);

		this.store = createStore(rootEpic);
		this.store.dispatch(initializeAppProps(this.props));
	}

	componentDidUpdate(prevProps: Props) {
		if (isShallowEqual(prevProps, this.props)) {
			return;
		}
		this.store.dispatch(initializeAppProps(this.props));
	}

	store: Store<State>;

	render() {
		return (
			<Provider store={this.store}>
				<AppStyle>
					<View />
				</AppStyle>
			</Provider>
		);
	}
}
